import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";
import { Router } from '@angular/router';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'app-nuevo-guia',
  templateUrl: './nuevo-guia.component.html',
  styleUrls: ['./nuevo-guia.component.scss'],
  providers: [MessagesTitles, MessagesStatus, AppComponent]
})
export class NuevoGuiaComponent implements OnInit {

  tipoSeleccionado: number = 0;

  @Output() cerrarPopUpGuia = new EventEmitter<boolean>();
  @Output() cerrarPopUpGuiaDetalle = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();

  disableSelect: boolean = false;
  viewSelect: boolean = true;
  editar: boolean;
  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  repSistemas: any = [];
  RepComponentes: any = [];
  arrayPadre: any = [];
  dataGuia: any;
  dataGuiaDetalle: any;
  id_sistema: any;
  user: any;
  ipAddress: any;
  formularioGuia: FormGroup;
  Titulo: string;
  nuevoDetalle: boolean;
  id_empresa: any;

  constructor(private securityService: SecurityService,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private componentePrincipal: AppComponent) {
    try {
      this.dataGuia = this.securityService.dataGuia;
      this.dataGuiaDetalle = this.securityService.dataGuiaDetalle;
    } catch (error) {
      this.router.navigate(['/componente/listado']);
    }

    this.Titulo = "Nueva Guia";
    this.editar = false;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.id_empresa = this.user.id_empresa;
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.formularioGuia = new FormGroup({
      idGuia: new FormControl(this.dataGuia.idGuia),
      id_sistemas: new FormControl('', [Validators.required]),
      id_empresa: new FormControl(this.id_empresa, [Validators.required]),
      idGuia_Padre: new FormControl('0', []),
      Codigo: new FormControl('', [Validators.required]),
      Descripcion: new FormControl('', [Validators.required]),
      Estado: new FormControl('1', []),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    },
    )
  }

  ngOnInit() {
    this.ObtenerListaSistemas();
    this.ObtenerListaComponentes();

    if (this.securityService.dataGuia != "") {
      this.disableSelect = true;
      this.viewSelect = false;
      this.loading = true;
      this.Titulo = "Editar guia";
      this.editar = true;
      this.formularioGuia.controls['Codigo'].setValue(this.dataGuia.Codigo);
      this.formularioGuia.controls['Descripcion'].setValue(this.dataGuia.Descripcion);
      this.formularioGuia.controls['id_sistemas'].setValue(this.dataGuia.id_sistemas);
      this.formularioGuia.controls['idGuia_Padre'].setValue(this.dataGuia.idGuia_Padre);
      this.FiltrarComponente(this.dataGuia.id_sistemas);

    }
    if (this.securityService.isDetalleGuia) {
      this.securityService.isDetalleGuia = false;
      this.disableSelect = true;
      this.viewSelect = false;
      this.loading = true;
      this.Titulo = "Nueva guia detalle";
      this.nuevoDetalle = true;
      this.formularioGuia.controls['id_sistemas'].setValue(this.dataGuiaDetalle.id_sistemas);
      this.formularioGuia.controls['idGuia_Padre'].setValue(this.dataGuiaDetalle.idGuia);
      this.FiltrarComponente(this.dataGuia.id_sistemas);

    }
    this.loading = false;
  }

  GuardarGuia() {

    if (this.formularioGuia.invalid) {

      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verficar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }

    if (this.editar) {

      Swal.fire({
        title: 'Espere',
        text: 'Actualizando Información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();


      this.securityService.ActualizarGuia(this.formularioGuia.getRawValue())
        .subscribe(resp => {
          this.componentePrincipal.Refresh();
          Swal.fire({
            title: "Éxito",
            text: "Guia actualizada correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitFunction(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "GUIA NO ACTUALIZADA. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else {

      Swal.fire({
        title: 'Espere',
        text: 'Guardando información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();
      this.securityService.RegistrarGuia(this.formularioGuia.getRawValue())
        .subscribe(resp => {
          this.componentePrincipal.Refresh();
          Swal.fire({
            title: "Éxito",
            text: "Guia registrada correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {

            this.emitFunction(res);

          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "GUIA NO GUARDADA. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }
  }

  emitFunction(res: SweetAlertResult) {
    if (res.value) {
      this.cerrarPopUpGuia.emit();
      this.refresh.emit();
    }
  }

  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  ObtenerListaComponentes() {
    this.loading = true;
    let tc = "";
    this.securityService.ObtenerListaComponentes(tc)
      .subscribe(resp => {
        this.RepComponentes = resp
        this.FiltrarCoomponentesPadres();
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA COMPONENTES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  FiltrarCoomponentesPadres() {
    this.RepComponentes.forEach(item => {
      if (item.id_componente_padre == 0) {
        this.arrayPadre.push(item);
      }      
    });
  }

  FiltrarComponente(element: any) {
    this.id_sistema = element;
    this.filterItemsOfId();
  }

  filterItemsOfId() {
    if (this.securityService.dataGuia != "") {
      return this.RepComponentes.filter(x => x.id_sistemas == this.id_sistema);

    } else {
      return this.arrayPadre.filter(x => x.id_sistemas == this.id_sistema);
    }
  }
  CerrarPopUp() {
    this.cerrarPopUpGuia.emit();
  }


}
